import React, { Dispatch, SetStateAction, useState } from "react";
import FileReference from "../components/Gallery/model/FileReference.model";
import GalleryFlag from "../components/Gallery/model/GalleryFlag.model";

export interface GalleryContextType {
  flags?: GalleryFlag[];
  files: FileReference[];
  attachmentDialogOpen: { flag?: GalleryFlag } | null;
  setFiles: Dispatch<SetStateAction<FileReference[]>>;
  setAttachmentDialogOpen: Dispatch<SetStateAction<{ flag?: GalleryFlag } | null>>;
}

export const GalleryContext = React.createContext<GalleryContextType>({
  files: [],
  attachmentDialogOpen: null,
  setFiles: () => {},
  setAttachmentDialogOpen: () => {},
});

export const GalleryContextProvider: React.FunctionComponent<{
  children?: JSX.Element;
  flags?: GalleryFlag[];
}> = (props) => {
  const [files, setFiles] = useState<FileReference[]>([]);
  const [attachmentDialogOpen, setAttachmentDialogOpen] = useState<{
    flag?: GalleryFlag;
  } | null>(null);
  const { children, flags } = props;
  return (
    <GalleryContext.Provider
      value={{
        flags,
        files,
        attachmentDialogOpen,
        setFiles,
        setAttachmentDialogOpen,
      }}
    >
      {children}
    </GalleryContext.Provider>
  );
};

export default GalleryContext;
